import { FieldArray, FormikProvider } from 'formik';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { Card, CardBody, FormFeedback, Input } from 'reactstrap';
import { postGstVerification, postIecVerification } from "../../../store/Settings/actions";
import { showErrorToast } from "../../../components/Common/CustomToast";

// const stateConverter = (num) => {
//     return placeOfSupply.find((place) => +place.Code === +num)?.value;
// };
const SettingsTaxDetails = ({ taxDetailsFormik, setGstModal }) => {
    const [viewGst, setViewGst] = useState(false);
    const stateAllData = useSelector((state) => state?.globalReducer?.stateAllData);
    const tax_code_master = useSelector((state) => state?.globalReducer?.tax_code_master);
    const { iecVerifications, gstVerifications } = useSelector((state) => state?.settings);
    const dispatch = useDispatch();
    const gstNumberHandler = (e) => {
        taxDetailsFormik.handleChange(e);
        // taxDetailsFormik.setFieldValue(
        //     "placeOfService",
        //     stateConverter(e.target.value.substring(0, 2))
        // );
    };
    const [iecNumberQuery, setIECNumberQuery] = useState('');
    const [iecNumberDebouncedQuery, setIECNumberDebouncedQuery] = useState('');
    const [gstNumberQuery, setGstNumberQuery] = useState("");
    const [gstNumberDebouncedQuery, setGstNumberDebouncedQuery] = useState('');


    useEffect(() => {
        const handler = setTimeout(() => {
            setIECNumberDebouncedQuery(iecNumberQuery);
        }, 500); // 500ms delay

        return () => {
            clearTimeout(handler);
        };
    }, [iecNumberQuery]);

    useEffect(() => {
        const handler = setTimeout(() => {
            setGstNumberDebouncedQuery(gstNumberQuery);
        }, 500); // 500ms delay

        return () => {
            clearTimeout(handler);
        };
    }, [gstNumberQuery]);

    useEffect(() => {
        if (iecNumberDebouncedQuery) {
            checkIecNumberIsValid(iecNumberDebouncedQuery);
        }
    }, [iecNumberDebouncedQuery]);


    useEffect(() => {
        if (gstNumberDebouncedQuery) {
            checkGstNumberIsValid(gstNumberDebouncedQuery);
        }
    }, [gstNumberDebouncedQuery]);

    const checkIecNumberIsValid = (number) => {
        console.log(number, "iecNumber");
        let payload = {
            iecNumber: number
        }
        dispatch(postIecVerification(payload));
    }

    const checkGstNumberIsValid = (number) => {
        console.log(number, "gstNumber");
        let payload = {
            gstNumber: number
        }
        dispatch(postGstVerification(payload));
    }

    useEffect(() => {
        if (iecVerifications?.Address === 'Data not available') {
            showErrorToast("Invalid IEC Number");
            taxDetailsFormik.setFieldValue("iecNumber", "");
        }
    }, [iecVerifications]);

    return (
        <>
            <Card id="taxDetails" className="my-4">
                <CardBody>
                    <div>
                        <h5>Tax Details</h5>
                    </div>

                    {/* <div className="row mt-4">
                        <div className="col-12 col-md-6 mb-4">
                            <label className="form-label">Pan Number</label>
                            <Input
                                type="text"
                                name="pan"
                                value={taxDetailsFormik?.values?.pan || ""}
                                onChange={taxDetailsFormik.handleChange}
                                onBlur={taxDetailsFormik.handleBlur}
                                className="form-control"
                                invalid={
                                    taxDetailsFormik.touched.pan &&
                                    taxDetailsFormik.errors.pan
                                      ? true
                                      : false
                                  }
                                placeholder="Enter the Permanent Account Number (PAN)..."
                            />
                            {taxDetailsFormik.touched.pan &&
                                taxDetailsFormik.errors.pan ? (
                                    <FormFeedback type="invalid">
                                        {taxDetailsFormik.errors.pan}
                                    </FormFeedback>
                                ) : null}
                        </div>
                        <div className="col-12 col-md-6 mb-4">
                            <label className="form-label">CIN Number</label>
                            <Input
                                type="text"
                                name="cin"
                                value={taxDetailsFormik?.values?.cin || ""}
                                onChange={taxDetailsFormik.handleChange}
                                onBlur={taxDetailsFormik.handleBlur}
                                className="form-control"
                                invalid={
                                    taxDetailsFormik.touched.cin &&
                                    taxDetailsFormik.errors.cin
                                      ? true
                                      : false
                                  }
                                placeholder="Enter the Corporate Identification Number (CIN)..."
                            />
                            {taxDetailsFormik.touched.cin &&
                                taxDetailsFormik.errors.cin ? (
                                    <FormFeedback type="invalid">
                                        {taxDetailsFormik.errors.cin}
                                    </FormFeedback>
                                ) : null}
                        </div>
                    </div> */}

                    <div className="row">
                        <div className="col-12 col-md-6">
                            <div className="mb-3">
                                <label className="form-label">Tax Identifier Type</label>
                                <Select
                                    name='taxCodeId'
                                    value={
                                        tax_code_master
                                            ? tax_code_master?.find(
                                                (option) =>
                                                    option.value ===
                                                    taxDetailsFormik?.values?.taxCodeId
                                            )
                                            : ""
                                    }
                                    onChange={(e) => {
                                        taxDetailsFormik.setFieldValue(
                                            `taxCodeId`,
                                            e.value
                                        );
                                    }}
                                    options={tax_code_master}
                                    classNamePrefix="select2-selection form-select"
                                />
                            </div>
                        </div>

                        <div className="col-12 col-md-6 mb-4">
                            <label className="form-label">Tax Number</label>
                            <Input
                                type="text"
                                name="no"
                                onChange={(e) => {
                                    setGstNumberQuery(e.target.value);
                                    gstNumberHandler(e);
                                }}
                                onBlur={taxDetailsFormik.handleBlur}
                                value={taxDetailsFormik?.values?.no || ""}
                                // value={modalAlldata?.no|| ''}
                                className="form-control"
                                invalid={
                                    taxDetailsFormik.touched.no &&
                                        taxDetailsFormik.errors.no ? (
                                        <FormFeedback type="invalid">
                                            {taxDetailsFormik.errors.no}
                                        </FormFeedback>
                                    ) : null
                                }
                                placeholder="Enter the 15-digit Goods and Services Tax Identification Number (GSTIN) .."
                            />
                            {taxDetailsFormik.touched.no &&
                                taxDetailsFormik.errors.no ? (
                                <FormFeedback type="invalid">
                                    {taxDetailsFormik.errors.no}
                                </FormFeedback>
                            ) : null}
                        </div>
                        {/* <div className="col-10 col-md-5 mb-4">
                            <label className="form-label">Place of Service</label>
                            <Select
                                value={stateAllData ? stateAllData.find((option) => option.value === taxDetailsFormik?.values?.placeOfService) : ""}
                                name="placeOfService"
                                options={stateAllData}
                                placeholder={"Select Place of service"}
                                onChange={(e) => {
                                    taxDetailsFormik.setFieldValue(`placeOfService`, e.value);
                                }}
                                classNamePrefix="select2-selection form-select"
                            />
                            {taxDetailsFormik.touched.placeOfService &&
                                taxDetailsFormik.errors.placeOfService ? (
                                    <FormFeedback type="invalid">
                                        {taxDetailsFormik.errors.placeOfService}
                                    </FormFeedback>
                                ) : null}
                        </div> */}
                        {/* <div className="col-2 col-md-1">
                            <button
                                disabled={true}
                                className="btn btn-primary mt-4"
                                onClick={() => setGstModal(true)}
                            >
                                <i className="bx bx-plus"></i>
                            </button>
                        </div> */}
                    </div>

                    {/* <div className="row mt-4 mb-2">
                        <a className="col-12 col-md-6 d-flex">
                            <p>{taxDetailsFormik?.values?.moreGstNumbers?.length} More GST available</p>
                            <p
                                className='ms-1'
                                onClick={() => {
                                    Gst
                                    setViewGst((prev) => !prev);
                                }}
                            >
                                <u>View {viewGst ? " less" : " More"}</u>
                            </p>
                        </a>
                    </div> */}
                    {/* ------------ map GST ------ */}
                    {viewGst && (
                        <FormikProvider value={taxDetailsFormik}>
                            <FieldArray name="moreGstNumbers" validateOnChange={false}>
                                {(arrayHelpers) => (
                                    <>
                                        {taxDetailsFormik?.values?.moreGstNumbers?.map((gst, index) => (
                                            <div className="row" key={index}>
                                                <div className="col-12 col-md-6 mb-4">
                                                    <label className="form-label">GST Number</label>
                                                    <Input
                                                        type="text"
                                                        name={`moreGstNumbers[${index}].no`}
                                                        onChange={(e) => {
                                                            setGstNumberQuery(e.target.value)
                                                            gstNumberHandler(e);
                                                        }}
                                                        value={taxDetailsFormik?.values?.moreGstNumbers?.[index]?.no}
                                                        className="form-control"
                                                        placeholder="Enter gst number..."
                                                    />
                                                </div>

                                                <div className="col-10 col-md-5 mb-4">
                                                    <label className="form-label"> Place of Supply </label>
                                                    <Select
                                                        value={stateAllData ? stateAllData.find((option) => option.value === taxDetailsFormik?.values?.moreGstNumbers?.[index]?.placeOfService) : ""}
                                                        name={`moreGstNumbers[${index}].placeOfService`}
                                                        options={stateAllData}
                                                        onChange={(e) => {
                                                            taxDetailsFormik.setFieldValue(`moreGstNumbers[${index}].placeOfService`, e.value);
                                                        }}
                                                        placeholder={"Select Place of service"}
                                                        classNamePrefix="select2-selection form-select"
                                                    />
                                                </div>
                                                <div className="col-2 col-md-1">
                                                    <button className="btn border mt-4" onClick={() => { arrayHelpers.remove(index); }}>
                                                        <i className="bx bx-trash fs-5 align-middle text-danger"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        ))}
                                        {/* <button type="button" className='btn btn-primary'
                                        onClick={() => arrayHelpers.push({
                                            gstNo: '',
                                            placeOfService: ''
                                        })}>
                                        Add
                                    </button> */}
                                    </>
                                )
                                }
                            </FieldArray>
                        </FormikProvider>
                    )}
                    {/* ----------- more GST --------------- */}

                    <div className="row">
                        <div className="d-flex justify-content-center">
                            <div className="mb-3 mx-3 d-flex justify-content-end">
                                <button
                                    type="submit"
                                    onClick={taxDetailsFormik.handleSubmit}
                                    className="btn btn-primary">
                                    Save
                                </button>
                            </div>
                            <div className="mb-3 mx-3 d-flex justify-content-end">
                                <button
                                    onClick={() => taxDetailsFormik.resetForm()}
                                    className="btn btn-primary"
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </CardBody>
            </Card>
        </>
    );
}

export default SettingsTaxDetails;
